import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import 'regenerator-runtime/runtime';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Banner from 'react-js-banner';

import { getUser, logout, getDMEClients } from '../../state/services/authService';
import { getStatusPageUrl } from '../../state/services/bookingService';
// import { openTab } from '../../commons/browser';

import logo from '../../public/images/dme_20250213.png';
import gw from '../../public/images/logos/gw.png';
import QuickQuotePopover from '../Popovers/QuickQuotePopover';
import SimpleTooltipComponent from '../Tooltip/SimpleTooltipComponent';
import { getCurrentSubdomain } from '../../commons/domain';

class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            username: '',
            findKeyword: '',
            isOpenQuickQuote: false,
            showBanner: false,
        };
    }

    static propTypes = {
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        clientname: PropTypes.string,
        dmeClients: PropTypes.array,

        // Functions
        getUser: PropTypes.func.isRequired,
        logout: PropTypes.func.isRequired,
        getStatusPageUrl: PropTypes.func.isRequired,
        getDMEClients: PropTypes.func.isRequired,
    };

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutsideQuickQuotePopover);
        const isLoggedIn = localStorage.getItem('isLoggedIn');
        const token = localStorage.getItem('token');

        if (isLoggedIn && token && token.length > 0)
            this.props.getUser(token);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutsideQuickQuotePopover);
    }

    handleClickOutsideQuickQuotePopover = (event) => {
        const quickPopoverElement = document.getElementsByClassName('quick-quote')[0];
        const extraLargeItemModal = document.getElementsByClassName('gw-extra-large-item-alert')[0];
        if (extraLargeItemModal) return;
        if (quickPopoverElement && !quickPopoverElement.contains(event.target)) {
            this.setState({ isOpenQuickQuote: false });
        }
    }
    
    UNSAFE_componentWillReceiveProps(newProps) {
        const { username, clientname, isLoggedIn, dmeClients } = newProps;
        if (isLoggedIn && (!dmeClients || !dmeClients.length)) {
            this.props.getDMEClients();
        }
        if (username)
            this.setState({ username });

        if (clientname)
            this.setState({ clientname });

        // if (statusPageUrl) {
        //     console.log('@1 - ', statusPageUrl);
        //     if (statusPageUrl === 'not_found')
        //         this.notify('Not found with "' + this.state.findKeyword + '"');
        //     else
        //         openTab(statusPageUrl);

        //     this.setState({isFindingBooking: false});
        // }
        this.setState({ isLoggedIn });
    }

    notify = (text) => toast(text);

    logout() {
        this.props.logout();
        this.props.history.push('/');
    }

    onOpenQuickQuote(e) {
        e.preventDefault();
        e.stopPropagation();
        const isLoggedIn = localStorage.getItem('isLoggedIn');
        if (isLoggedIn === 'true' && this.props.clientname) {
            this.setState({ isOpenQuickQuote: !this.state.isOpenQuickQuote });
        }
    }

    onClickCreateBooking(e) {
        e.preventDefault();
        const isLoggedIn = localStorage.getItem('isLoggedIn');
        if (isLoggedIn === 'true') {
            this.props.history.push('/create-a-booking');
        } else {
            this.notify('Please login first.');
        }
    }

    closeBanner() {
        this.setState({ showBanner: false });
    }

    render() {
        const { username, isOpenQuickQuote, showBanner } = this.state;
        const { clientname, dmeClients } = this.props;
        const currentRoute = this.props.location.pathname;
        const isLoggedIn = localStorage.getItem('isLoggedIn');
        const isGW = getCurrentSubdomain().indexOf('gw') !== -1 || 
            (isLoggedIn && clientname === 'Gebrüder Weiss') ||
            localStorage.getItem('theme') === 'gw-theme';

        if (currentRoute.indexOf('admin') > -1 || currentRoute.indexOf('customerdashboard') > -1 || currentRoute.indexOf('status') > -1)
            return null;
        return (
            <header className={isGW ? 'gw-header' : ''}>
                {currentRoute === '/booking' ||
                    currentRoute === '/create-a-booking' ||
                    currentRoute === '/allbookings' ||
                    currentRoute === '/bookingsets' ||
                    currentRoute === '/bookinglines' ||
                    currentRoute === '/bookinglinedetails' ||
                    currentRoute === '/pods' ||
                    currentRoute === '/reports' ||
                    currentRoute === '/warehouse-label' ?
                    <nav className="qbootstrap-nav" role="navigation">
                        <div id='headr' className='col-md-12'>
                            <div className="top d-flex">
                                {isGW ? 
                                    <div className="logo">
                                        <a href="/" className="navbar-brand mr-sm-0">
                                            <img src={gw} className="head-logo" alt="logo" />
                                        </a>
                                    </div>
                                    : null
                                }
                                <div className="row d-flex flex-grow-1">
                                    <div className="col-md-8 col-sm-12 col-lg-8 col-xs-12 col-md-push-1 ">
                                        <h3 className="label_hel"><a href="/">Company: {clientname ? clientname : '---'}    User: {username ? username : '---'}</a></h3>
                                        <h3 className="label_hel"></h3>
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-lg-4 col-xs-12 text-right col-lg-pull-1">
                                        <a href="" className="none">Login Info Client</a>
                                        <span className="none">|</span>
                                        <a href="" className="none">Accounts</a>
                                        <span className="none">|</span>
                                        <a href="" className="none">Client Mode</a>
                                        <span className="none">|</span>
                                        {(username !== 'anchor_packaging_afs' &&  username !== 'tempo_calm') &&
                                            <a
                                                id="Popover"
                                                href='#'
                                                onClick={(e) => this.onOpenQuickQuote(e)}
                                                className='popover-btn'
                                            >
                                                Quick Quote
                                            </a>
                                        }
                                        {(username !== 'anchor_packaging_afs' &&  username !== 'tempo_calm') &&
                                            <QuickQuotePopover
                                                isOpen={isOpenQuickQuote}
                                                setIsOpen={(val) => { this.setState({ isOpenQuickQuote: val }); }}
                                                dmeClients={dmeClients}
                                            />
                                        }
                                        {(username !== 'anchor_packaging_afs' &&  username !== 'tempo_calm') && <span>|</span>}
                                        <a href="/">Home</a>
                                    </div>
                                </div>
                            </div>
                            <div className="line"></div>
                        </div>
                    </nav>
                    :
                    currentRoute.startsWith('/bid') || 
                    currentRoute.startsWith('/confirm') || 
                    currentRoute.startsWith('/approve') || 
                    currentRoute.startsWith('/disapprove') ?
                        <nav className="navbar navbar-expand bg-nav pl-md-5 ml-md-0">
                            <div className="col-sm-12">
                                {isGW ?
                                    (<a href="/" className="navbar-brand mr-sm-0">
                                        <img src={gw} className="head-logo" alt="logo" />
                                    </a>)
                                    : 
                                    (<React.Fragment>
                                        <a href="/" className="navbar-brand mr-sm-0">
                                            <img src={logo} className="head-logo" alt="logo" />
                                        </a>
                                        <h5>Tel: (02) 8311 1500</h5>
                                    </React.Fragment>)
                                }
                            </div>
                        </nav>
                        :
                        <nav className="navbar navbar-expand bg-nav pl-md-5 ml-md-0">
                            <div className="col-sm-6">
                                {isGW ?
                                    (<a href="/" className="navbar-brand mr-sm-0">
                                        <img src={gw} className="head-logo" alt="logo" />
                                    </a>)
                                    : 
                                    (<React.Fragment>
                                        <a href="/" className="navbar-brand mr-sm-0">
                                            <img src={logo} className="head-logo" alt="logo" />
                                        </a>
                                        <h5>Tel: (02) 8311 1500</h5>
                                    </React.Fragment>)
                                }
                            </div>
                            <div className="col-sm-6 d-flex justify-content-between">
                                {(username !== 'anchor_packaging_afs' &&  username !== 'tempo_calm' && !currentRoute.startsWith('/label') ) &&
                                    <div id={'booking-column-header-tooltip-LoginRequired'}>
                                        {(isLoggedIn !== 'true' || clientname === '') && <SimpleTooltipComponent text={'Login Required'} />}
                                        <a
                                            id="Popover"
                                            className={`btn btn-outline-light my-2 my-lg-0 login ${(isLoggedIn !== 'true' || clientname === '') && 'disabled'}`}
                                            onClick={(e) => this.onOpenQuickQuote(e)}
                                        >
                                            Quick Quote
                                        </a>
                                        <QuickQuotePopover isOpen={isOpenQuickQuote} setIsOpen={(val) => { this.setState({ isOpenQuickQuote: val }); }} dmeClients={dmeClients} />
                                    </div>
                                }
                                {!currentRoute.startsWith('/label')  &&
                                    <div className="create-a-booking">
                                        <a
                                            className={'btn btn-outline-light my-2 my-lg-0'}
                                            onClick={(e) => this.onClickCreateBooking(e)}
                                        >
                                            Create Booking
                                        </a>
                                    </div>
                                }
                                <ul className="navbar-nav flex-row ml-auto d-md-flex">
                                    {clientname && isLoggedIn === 'true' ?
                                        <li className="nav-item dropdown show">
                                            <a className="nav-item nav-link dropdown-toggle mr-md-2" href="#" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                                <i className="fa fa-user" aria-hidden="true"></i>
                                            </a>
                                            {(username === 'anchor_packaging_afs' || username === 'tempo_calm') ?
                                                <div className="dropdown-menu dropdown-menu-right" aria-labelledby="bd-versions">
                                                    <a className="dropdown-item cut-user-name">
                                                        <i>Logged in as {username}</i>
                                                    </a>
                                                    <div className='dropdown-divider'></div>
                                                    <a className='dropdown-item' href="/warehouse-label">Labels</a>
                                                    <div className="dropdown-divider"></div>
                                                    <a className="dropdown-item" href="/" onClick={() => this.logout()}>Logout</a>
                                                </div>
                                                :
                                                <div className="dropdown-menu dropdown-menu-right" aria-labelledby="bd-versions">
                                                    <a className="dropdown-item cut-user-name">
                                                        <i>Logged in as {username}</i>
                                                    </a>
                                                    {clientname === 'dme' && <div className='dropdown-divider'></div>}
                                                    {clientname === 'dme' && <a className='dropdown-item' href="/admin">DME Admin</a>}
                                                    {clientname != 'dme' && <a className='dropdown-item' href="/customerdashboard">Admin</a>}
                                                    {clientname === 'dme' && <div className="dropdown-divider"></div>}
                                                    {clientname === 'dme' && <a className="dropdown-item" href="/upload">Upload Files</a>}
                                                    {(clientname === 'dme' || clientname === 'Tempo Pty Ltd') && <div className="dropdown-divider"></div>}
                                                    {(clientname === 'dme' || clientname === 'Tempo Pty Ltd') && <a className="dropdown-item" href="/files">Files</a>}
                                                    <div className="dropdown-divider"></div>
                                                    <a className="dropdown-item" href="/bok">Find Order</a>
                                                    <div className="dropdown-divider"></div>
                                                    <a className="dropdown-item" href="/booking">Booking</a>
                                                    <div className="dropdown-divider"></div>
                                                    <Link className="dropdown-item" to="/allbookings">All Bookings</Link>
                                                    {clientname === 'dme' && <div className='dropdown-divider'></div>}
                                                    {clientname === 'dme' && <a className='dropdown-item' href="/reports">Reports</a>}
                                                    <div className="dropdown-divider"></div>
                                                    <a className="dropdown-item" href="/" onClick={() => this.logout()}>Logout</a>
                                                </div>
                                            }
                                        </li>
                                        :
                                        <li className="nav-item">
                                            {
                                                currentRoute.indexOf('/status/') === 0 ||
                                                currentRoute.indexOf('/label/') === 0 ?
                                                    null : <a href="/login" className="btn btn-outline-light my-2 my-lg-0 login">Login</a>
                                            }
                                        </li>
                                    }
                                </ul>
                            </div>
                        </nav>
                }

                <ToastContainer />

                <Banner 
                    css={{ color: '#000', backgroundColor: 'grey', position: 'absolute', top: '0px', width: '50%', left: '25%', padding: '0' }} 
                >
                    <div className={showBanner ? 'banner-close' : 'none'}>
                        <span>ETA: with 2-day delay (holidays)</span>
                        <i className="fa fa-times-circle p-2 c-orange" onClick={() => this.closeBanner()}></i>
                    </div>
                </Banner>
            </header>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        username: state.auth.username,
        clientname: state.auth.clientname,
        isLoggedIn: state.auth.isLoggedIn,
        statusPageUrl: state.booking.statusPageUrl,
        dmeClients: state.auth.dmeClients,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getUser: (token) => dispatch(getUser(token)),
        logout: () => dispatch(logout()),
        getStatusPageUrl: (findKeyword) => dispatch(getStatusPageUrl(findKeyword)),
        getDMEClients: () => dispatch(getDMEClients()),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));



// WEBPACK FOOTER //
// ./src/components/Header/Header.js